import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Sign Up with "),
  /*#__PURE__*/_createElementVNode("b", null, "Email")
], -1)
const _hoisted_2 = { class: "bottom-text" }
const _hoisted_3 = { class: "account" }

import Exit from "@/components/svgs/Exit.vue";
import AuthModal from "@/components/AuthModal.vue";
import { showSignupModal, showLoginModal } from "@/refs/modals";

export default /*#__PURE__*/_defineComponent({
  __name: 'SignupModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(showSignupModal))
    ? (_openBlock(), _createBlock(AuthModal, { key: 0 }, {
        title: _withCtx(() => [
          _createElementVNode("span", {
            class: "exit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSignupModal.value = false))
          }, [
            _createVNode(Exit)
          ]),
          _hoisted_1
        ]),
        input: _withCtx(() => []),
        button: _withCtx(() => []),
        extra: _withCtx(() => [
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(" By signing up you agree to our "),
            _createVNode(_component_router_link, {
              to: "terms-of-service",
              class: "link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showSignupModal.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Terms ")
              ]),
              _: 1
            }),
            _createTextVNode(" and "),
            _createVNode(_component_router_link, {
              to: "privacy-policy",
              class: "link",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showSignupModal.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Privacy Policy")
              ]),
              _: 1
            }),
            _createTextVNode(". ")
          ]),
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(" Already have an account? "),
            _createElementVNode("a", {
              class: "link",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {
						showLoginModal.value = true;
						showSignupModal.value = false;
					})
            }, "Sign in.")
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})